import { generatePath, Navigate, Outlet, useLocation } from 'react-router'
import { useAccount } from 'shared-ui/active-operation'
import { AppCrashFallback, Loading } from 'shared-ui/components'

import { path } from '../../../routes/paths'
import { AuthStatus, useAuth } from '../contexts/auth'

export const RequireAuthGuard: React.FC = () => {
  const auth = useAuth()
  const account = useAccount()
  const location = useLocation()

  if (account.isError) {
    return <AppCrashFallback error={account.error} signOut={auth.signOut} />
  }

  switch (auth.status) {
    case AuthStatus.Authenticated:
      return <Outlet />

    case AuthStatus.Unauthenticated: {
      const redirectUrl = location.pathname + location.search
      const destination = redirectUrl === '/' ? path.publicLanding : path.loginRequired
      return <Navigate to={generatePath(destination)} state={{ redirectUrl }} replace />
    }

    case AuthStatus.Authenticating:
      return <Loading />

    case AuthStatus.Unknown:
      return <Loading />
  }
}
